import { fixtureClient } from "./fixtures";
import { createHttpClient } from "./http";
import type { Aux0Client } from "./types";

export { Aux0ApiError, UnavailableDataError } from "./errors";
export type { Aux0Client } from "./types";

/**
 * Mode is explicit. A URL is ONLY an origin, never an adapter switch.
 * Local development uses the unhappy fixtures; production uses per-method
 * console capabilities. Missing console methods never return demo data.
 * Screenshot builds must explicitly use VITE_DATA_MODE=fixtures.
 */
const mode =
  import.meta.env?.VITE_DATA_MODE ?? (import.meta.env?.DEV ? "fixtures" : "http");
if (mode !== "fixtures" && mode !== "http")
  throw new Error("VITE_DATA_MODE must be fixtures or http");
export const coreUrl = (
  import.meta.env?.VITE_AUX0_API_ORIGIN ??
  import.meta.env?.VITE_CORE_URL ??
  "https://api.aux0.com"
).replace(/\/$/, "");

let unauthorized = false;
const sessionExpiredListeners = new Set<() => void>();
export function onSessionExpired(listener: () => void) {
  sessionExpiredListeners.add(listener);
  return () => {
    sessionExpiredListeners.delete(listener);
  };
}
function sessionExpired() {
  if (unauthorized) return;
  unauthorized = true;
  for (const listener of sessionExpiredListeners) listener();
  window.location.replace(`${coreUrl}/console/sign-in`);
}
const build = (project?: string): Aux0Client =>
  mode === "fixtures"
    ? fixtureClient
    : createHttpClient({ baseUrl: coreUrl, project, onUnauthorized: sessionExpired });
export const client = build();
const scoped = new Map<string, Aux0Client>();
/** Scope is passed by the route, never taken from mutable window.location. */
export function clientForProject(project: string): Aux0Client {
  let value = scoped.get(project);
  if (!value) {
    value = build(project);
    scoped.set(project, value);
  }
  return value;
}
